import Param from './param';
import Util from './module/libs/util';
import topManager from './page/top';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';
import webglManager from './module/webgl/manager';
import globalNavi from './module/global/globalNavi';
import spTurnDevice from './module/global/spTurnDevice';


const param = new Param();
const util = new Util();
let scroll;
let mouse;
let toppage;
let webgl = new webglManager();
let gnavi = new globalNavi();
let turnDevice;

// const stats = new Stats();
// stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild( stats.dom );

let pageID = $("body").attr("id");
let executionType = "landing"; /* 実行タイミングの制御用 */
let fpsRate = 0;

let device = Useragnt.mobile||Useragnt.tablet ? "sp" : "pc";
let webglOn = device == "pc"&&!Useragnt.tablet ? true : false;

/* ---------------------------------------------------

  -- render

 --------------------------------------------------- */

let render = function () {
    if(!requestAnimationFrame){
        setTimeout(function () {
            render;
        },1000/60);
    }else{
        requestAnimationFrame(render);
    }

    fpsRate = util.updateTimeRatio();


    // stats.begin();

    scroll.move(fpsRate,toppage.status.act.flg);
    if(scroll.controll.current<=3) mouse.move(fpsRate);
    if(!Useragnt.ie&&!Useragnt.edge&&webglOn&&fpsRate<1.5) webgl.render(mouse.obj,scroll.controll.current);
    toppage.render(mouse.obj,scroll.controll.current,scroll.inc,fpsRate);
    if(toppage.status.act.fixbtn.fit&&device==="sp") _mouseMoveCtrl(0,0);
    // stats.end();

}

/* ---------------------------------------------------

  --

 --------------------------------------------------- */


let common = function () {

    scroll = new smoothScrollManager(device);
    mouse = new MouseManager();
    if(executionType==="landing"&&!Useragnt.ie&&!Useragnt.edge&&webglOn) webgl.init();
    gnavi.init();
    turnDevice = new spTurnDevice(device);


    setTimeout(function(){
        resize();
        scroll.init(pageID);
        if(executionType==="landing") render();
        },1e2);
    pageManager(pageID);
}

let pageManager = function(){

    switch(pageID){
        case "top":
            toppage = new topManager(device);
            toppage.init();
            break;
    }

}

let resize = function () {


    let _w = window.innerWidth,
        _h = window.innerHeight;

    param.displayType = ( window.innerWidth>param.breakpoint )?"pc":"sp";



    if(pageID==="top")toppage.resize(_w,_h);

    if(!Useragnt.ie&&!Useragnt.edge&&webglOn) webgl.resize();
    scroll.resize(param.displayType);



}


/* ---------------------------------------------------

  -- load

 --------------------------------------------------- */

$(window).on("load", function (e) {
    executionType = "landing";
    TweenMax.set($("#l-root"),{opacity:1});
    common();
    $('html,body').animate({ scrollTop: 0 }, '1');

});

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */

let _sectionChange = ((e,dir)=>{


    if(toppage.act.status.selected&&device==="pc"&&!Useragnt.tablet||!toppage.status.splashFlg||!scroll.controll.spScFlg){
        if(!Useragnt.android)
            e.preventDefault();
        else
            e.stopPropagation();
        return;
    }
    scroll.dir = dir;
    if(scroll.controll.type == "full") {
        if(!Useragnt.android)
            e.preventDefault();
        else
            e.stopPropagation();
        scroll.update(0,"");
        // mouse.move();
    }


})


let _mousewheelevent = "onwheel" in document.createElement("div") ? "wheel" :  document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll";
$(window).on(_mousewheelevent, function(e) {
    /* スクロールの方向だけ取得 */
    let _delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
    _sectionChange(e,_delta < 0 ? "next" : "prev")

});

let touchInc = {
    x : 0,
    y : 0
}
let touchMoveFlg = false;

window.addEventListener("touchstart",function (e) {
    touchInc.x = e.changedTouches[0].pageX;
    touchInc.y = e.changedTouches[0].pageY;
});
let _touchMoveReset = false;
window.addEventListener("touchmove",function (e) {

    if(scroll.controll.current==0) scroll.controll.spKvFlg=true; /* スマホで意図しないKVでのスクロールを防止 */

    if(toppage.act.status.selected&&device==="pc"&&!Useragnt.tablet||!toppage.status.splashFlg||!scroll.controll.spScFlg){


        e.preventDefault();
        e.stopPropagation();
        return;
        // if(!Useragnt.mobile) return;

        // if(!_touchMoveReset){
        //     _touchMoveReset = true;
        //     setTimeout(()=>{
        //         _touchMoveReset = scroll.controll.spKvFlg = false;
        //     },2e3)
        // }else{
        //     return;
        // }
    }
    touchMoveFlg = true;

});
window.addEventListener("touchend",function (e) {

    let _x = e.changedTouches[0].pageX,
        _y = e.changedTouches[0].pageY;

    if(Useragnt.tablet) _mouseMoveCtrl(_x,_y);


    if(toppage.act.status.selected||!toppage.status.splashFlg) return;
    if(touchInc.y>_y)
        if(touchMoveFlg) _sectionChange(e,"next")
    else
        if(touchMoveFlg) _sectionChange(e,"prev")


});

document.onkeydown = function(e) {
    if(e.keyCode===38){
        _sectionChange(e,"prev")
    }else if(e.keyCode===40){
        _sectionChange(e,"next")
    }
}


let _mouseMoveCtrl = (x,y)=>{
    if(toppage===undefined) return;
    if(!toppage.status.act.fixbtn.fit){
        mouse.update(x,y);
    }else{
        if(toppage.status.act.select.day==="18"){

            mouse.update(
                toppage.w-toppage.status.act.fixbtn.size.full+toppage.status.act.fixbtn.size.half-30,
                30 + toppage.status.act.fixbtn.size.half
            );
        }else{

            mouse.update(
                toppage.w-toppage.status.act.fixbtn.size.full+toppage.status.act.fixbtn.size.half-30-(toppage.w*0.165),
                30 + toppage.status.act.fixbtn.size.half
            );
        }

    }
}
let _prevScrollInc = 0;
$(window).on("scroll", function (e) {

    let _y = window.pageYOffset || document.documentElement.scrollTop;

    if(device=== "sp"&& _y==0&&!toppage.act.status.selected){
        /* iPhoneの機能でページトップに戻った時の対策 */
        // scroll.controll.type = "smooth";
        scroll.controll.current = 0;
    }


    _prevScrollInc = _y;

    if(scroll.controll.type == "full"||toppage.act.status.selected||!toppage.status.splashFlg||!scroll.controll.spScFlg) return;
    scroll.update(_y,_y>_prevScrollInc?"next":"prev");
});



if(Useragnt.pc){
    window.addEventListener("mousemove",function (e) {

        let _x = e.clientX;
        let _y = e.clientY;

        _mouseMoveCtrl(_x,_y);

    });
}else{
    // window.addEventListener("deviceorientation",function (e) {
    //
    //
    //     const _degtorad = Math.PI / 180;
    //
    //     const _x = e.beta ? e.beta * _degtorad : 0;
    //     const _y = e.gamma ? e.gamma * _degtorad : 0;
    //     const _z = e.alpha ? e.alpha * _degtorad : 0;
    //
    //     const _sX = Math.sin(_x);
    //     const _sY = Math.sin(_y);
    //
    //
    //     // mouse.update(_sX,_sY);
    //
    // });
}

$(window).on("resize",function (e) {
    if(_orientationchangeFlg) return;
    executionType = "resize";
    resize();
});
let _orientationchangeFlg = false,
    _orientationchangeTimer;
window.addEventListener("orientationchange", function() {
    executionType = "onorientationchange";
    _orientationchangeFlg = true;
    if(device==="sp"&&!Useragnt.tablet){
        turnDevice.resize();
    }else{
        resize();
        if(Useragnt.tablet) scroll.update(window.pageYOffset || document.documentElement.scrollTop,"");

    }

    _orientationchangeTimer = setTimeout(()=> _orientationchangeFlg=false,1e2);

});